module.exports = __webpack_public_path__ + "img/pentagon.0e1ebc54.svg";